require("jquery.marquee");

export const init = () => {
    if ($('.home-marquee').data('runningStatus') !== 'resumed') {
        $('.home-marquee').marquee({
            speed: 100,
            gap: 0,
            direction: 'left',
            duplicated: true,
            duplicateCount: 3,
            pauseOnHover: true,
            startVisible: true
        });
    }
}